const s = { attrs: {} };

export const htmlSchema = {
	a: {
		attrs: {
			href: [],
			rel: ['noopener', 'noreferrer', 'nofollow'],
			target: ['_blank'],
			class: [
				'showtip indexable',
				'footnote-ref',
				'footnote-anchor',
				'webtext-big-link',
				'webtext-big-link-article'
			],
			title: [],
			name: [],
			end: [],
			start: [],
			'waveform-player-ref': [],
			'lms-course-redirect': ['course'],
			'aria-label': []
		}
	},
	b: s,
	blockquote: s,
	br: s,
	cite: s,
	col: { attrs: { style: [] } },
	colgroup: s,
	div: {
		attrs: {
			class: [
				'webtext-example',
				'webtext-callout',
				'webtext-callout-gutter',
				'webtext-pull-quote',
				'webtext-investigation-objective',
				'webtext-image-description',
				'webtext-excerpt-credits',
				'webtext-apa-reference-list',
				'webtext-article-source',
				'webtext-decoration',
				'webtext-objective',
				'webtext-placard',
				'webtext-source-attribution',
				'webtext-primary-source',
				'webtext-primary-source-attributes',
				'webtext-primary-source-content',
				'webtext-primary-source-separator',

				'learning-objectives',

				'webtext-example webtext-decoration right',
				'webtext-example webtext-decoration wrong',
				'webtext-example webtext-decoration star',

				'webtext-callout unstyled',
				'webtext-callout webtext-callout-gutter quill',
				'webtext-callout webtext-callout-gutter scales-of-justice',
				'webtext-callout webtext-callout-gutter texas',
				'webtext-callout marker-icon document',
				'webtext-callout webtext-callout-gutter mobile-tip',
				'webtext-callout marker-icon scales-of-justice',

				'webtext-pull-quote tech-tip',

				'heading',
				'footnotes',
				'name',
				'title',
				'dateline',
				'byline',
				'subtitle',
				'blurb',
				'case-name',
				'case-number',
				'case-date',
				'case-appellate',
				'internal-heading',
				'artwork',
				'detail',
				'description',
				'glossary'
			],
			id: ['chapter-splash-description']
		}
	},
	em: s,
	h1: {
		attrs: {
			class: [
				'webtext-page-title',
				'webtext-callout-gutter',

				'webtext-page-title webtext-callout-gutter papers-with-eye',
				'webtext-page-title webtext-callout-gutter communication',
				'webtext-page-title webtext-callout-gutter relationship-building',
				'webtext-page-title webtext-callout-gutter mobile-tip',
				'webtext-page-title webtext-callout-gutter initiative'
			],
			id: []
		}
	},
	h2: {
		attrs: {
			class: [
				'webtext-page-title',
				'webtext-content-author',
				'webtext-callout-gutter',

				'webtext-callout-gutter problem-solving',
				'webtext-callout-gutter head-with-gear',
				'webtext-callout-gutter social-connections',
				'webtext-callout-gutter agility',
				'webtext-callout-gutter papers-with-pencil',
				'webtext-callout-gutter communication',
				'webtext-callout-gutter innovation',
				'webtext-callout-gutter technology',
				'webtext-callout-gutter results-driven',
				'webtext-callout-gutter functionalism-theory-38c0c5',
				'webtext-callout-gutter frame-with-eye',
				'webtext-callout-gutter papers-magnifying-glass',
				'webtext-callout-gutter brain-head',
				'webtext-callout-gutter scales-of-justice',
				'webtext-callout-gutter papers-with-eye',
				'webtext-callout-gutter emotional-intelligence',
				'webtext-callout-gutter productivity',
				'webtext-callout-gutter symbolic-interaction-38c0c5',
				'webtext-callout-gutter elections',
				'webtext-callout-gutter conflict-theory-38c0c5',
				'webtext-callout-gutter grassroots-mobilization',
				'webtext-callout-gutter feminist-theory-38c0c5',
				'webtext-callout-gutter document',
				'webtext-callout-gutter business-connections',
				'webtext-callout-gutter self-care',
				'webtext-callout-gutter conflict-theory',
				'webtext-callout-gutter symbolic-interaction',
				'webtext-callout-gutter functionalism-theory',
				'webtext-callout-gutter ethics',
				'webtext-callout-gutter self-and-social-awareness',
				'webtext-callout-gutter stop-sign readable',
				'webtext-callout-gutter global',
				'webtext-callout-gutter cultural-change',

				'webtext-page-title webtext-callout-gutter functionalism-theory',
				'webtext-page-title webtext-callout-gutter conflict-theory',
				'webtext-page-title webtext-callout-gutter symbolic-interaction'
			],
			id: []
		}
	},
	h3: {
		attrs: {
			class: [
				'webtext-page-title',
				'webtext-content-author',
				'webtext-content-translator',
				'webtext-callout-gutter',
				'webtext-callout-heading',
				'webtext-callout-heading-camera',
				'webtext-callout-heading-news',

				'learning-objectives',

				'webtext-callout-gutter head-with-gear',
				'webtext-callout-gutter social-connections',
				'webtext-callout-gutter frame-with-eye',
				'webtext-callout-gutter papers-magnifying-glass',
				'webtext-callout-gutter papers-with-eye',
				'webtext-callout-gutter productivity',
				'webtext-callout-gutter technology',
				'webtext-callout-gutter papers-with-pencil',
				'webtext-callout-gutter symbolic-interaction',
				'webtext-callout-gutter innovation',
				'webtext-callout-gutter problem-solving',
				'webtext-callout-gutter self-and-social-awareness',
				'webtext-callout-gutter relationship-building',
				'webtext-callout-gutter brain-head',
				'webtext-callout-gutter results-driven',
				'webtext-callout-gutter ethics',
				'webtext-callout-gutter initiative'
			]
		}
	},
	h4: {
		attrs: {
			class: [
				'webtext-page-title',
				'webtext-content-author',
				'webtext-callout-heading',
				'webtext-callout-heading-camera'
			],
			id: []
		}
	},
	h5: s,
	h6: s,
	i: s,
	iframe: {
		attrs: {
			src: [],
			frameborder: ['no'],
			name: [],
			width: [],
			height: [],
			scrolling: ['no'],
			allow: ['autoplay'],
			allowfullscreen: []
		}
	},
	img: {
		attrs: {
			alt: [],
			src: [],
			width: [],
			height: [],
			class: ['webtext-figure-asset', 'webtext-figure-asset-image']
		}
	},
	li: {
		attrs: {
			class: ['webtext-list-item-bullet', 'download']
		}
	},
	math: {
		attrs: {
			display: ['block', 'inline'],
			overflow: ['scroll'],
			xmlns: ['http://www.w3.org/1998/Math/MathML']
		}
	},
	ol: {
		attrs: {
			start: [],
			style: [],
			id: [],
			class: ['webtext-ciag-centralideas-list', 'webtext-twg-outline', 'orderedlist']
		}
	},
	p: {
		attrs: {
			class: [
				'webtext-page-instruction',
				'webtext-image-caption',
				'webtext-time-estimate',
				'webtext-source-attribute',
				'webtext-source-title',
				'artist'
			],
			id: [],
			'data-label': [],
			role: [],
			'aria-level': []
		}
	},
	ref: {
		attrs: {
			'data-reference-id': [],
			'data-reference-type': [],
			'data-source-ids': [],
			'data-reference-override-presentation': [],
			'data-citation-prefix': [],
			'data-citation-suffix': [],
			'data-reference-page-only': []
		}
	},
	span: {
		attrs: {
			'data-source-family-id': [],
			'data-figure-id': [],
			'data-format': [],
			class: [
				'visually-hidden',

				'webtext-decoration',
				'webtext-figure-reference',
				'webtext-big-link-title',
				'webtext-big-link-credit',
				'webtext-source-url',
				'webtext-math',
				'webtext-pullquote-heading',
				'webtext-glossary-term-locations',
				'webtext-article-source-name',

				'wiley-link',
				'footnote-ref-tail',
				'icon-tech-tip',
				'keyterm-definition',
				'MsoHyperlink',
				'redactor-preserve-this',
				'rs_preserve',
				'sr-only'
			],
			style: [
				'padding-left: 1em',
				'padding-left: 2em',
				'padding-left: 4em',
				'padding-left: 10em',
				'padding-left: 20em',
				'padding-left: 40px'
			]
		}
	},
	strong: {
		attrs: {
			class: ['cnx-underline']
		}
	},
	style: {
		attrs: {
			type: ['text/css']
		}
	},
	sub: s,
	sup: s,
	table: {
		attrs: {
			id: [],
			border: [],
			cellpadding: [],
			width: [],
			class: ['webtext-figure-asset', 'webtext-figure-asset-table', 'webtext-performance-script']
		}
	},
	tbody: s,
	td: s,
	th: s,
	thead: s,
	tr: {
		attrs: {
			class: ['no-gap']
		}
	},
	ul: {
		attrs: {
			id: []
		}
	}
};
